import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalWrapperComponent } from '@myapp/features/widgets/components';
import { SharedUICheckboxComponent, SharedUiDropdownComponent, SharedUiTextInputComponent } from '../../../../../modules/forms';
import { BaseEditorComponent } from '../../base-editor/base-editor.component';
import { UserForm } from './user.form';

@Component({
  selector: 'app-users-editor',
  templateUrl: './users-editor.component.html',
  styleUrls: ['./users-editor.component.scss'],
  standalone: true,
  imports: [ModalWrapperComponent, FormsModule, SharedUiTextInputComponent, SharedUiDropdownComponent, SharedUICheckboxComponent]
})
export class UsersEditorComponent extends BaseEditorComponent {
  @Input() form?: UserForm;

  ngOnInit() {
    super.ngOnInit();
  }

}
